export { MotionConfig, MotionConfigContext } from './context/MotionConfigContext.js';
export { PresenceContext } from './context/PresenceContext.js';
export { useIsPresent, usePresence } from './components/AnimatePresence/use-presence.js';
export { LayoutGroupContext } from './context/LayoutGroupContext.js';
export { VisibilityAction } from './components/AnimateSharedLayout/types.js';
export { createBatcher } from './components/AnimateSharedLayout/utils/batcher.js';
export { FramerTreeLayoutContext, SharedLayoutContext } from './context/SharedLayoutContext.js';
export { createMotionComponent } from './motion/index.js';
export { useDomEvent } from './events/use-dom-event.js';
export { Drag as DragFeature } from './motion/features/drag.js';
export { usePanGesture } from './gestures/use-pan-gesture.js';
export { useTapGesture } from './gestures/use-tap-gesture.js';
export { useGestures } from './gestures/use-gestures.js';
export { Gestures as GesturesFeature } from './motion/features/gestures.js';
export { Exit as ExitFeature } from './motion/features/exit.js';
export { MotionValue, motionValue } from './value/index.js';
export { animateVisualElement } from './render/utils/animation.js';
export { animationControls } from './animation/animation-controls.js';
export { Animation as AnimationFeature } from './motion/features/animation.js';
export { AnimateLayout as AnimateLayoutFeature } from './motion/features/layout/Animate.js';
export { addScaleCorrection } from './render/dom/projection/scale-correction.js';
export { isValidMotionProp } from './motion/utils/valid-prop.js';
export { visualElement } from './render/index.js';
export { resolveMotionValue } from './value/utils/resolve-motion-value.js';
export { createDomMotionComponent, motion } from './render/dom/motion.js';
export { m } from './render/dom/motion-minimal.js';
export { AnimatePresence } from './components/AnimatePresence/index.js';
export { animate } from './animation/animate.js';
export { createCrossfader } from './components/AnimateSharedLayout/utils/crossfader.js';
export { AnimateSharedLayout } from './components/AnimateSharedLayout/index.js';
export { useMotionValue } from './value/use-motion-value.js';
export { useMotionTemplate } from './value/use-motion-template.js';
export { transform } from './utils/transform.js';
export { useTransform } from './value/use-transform.js';
export { useSpring } from './value/use-spring.js';
export { useVelocity } from './value/use-velocity.js';
export { useElementScroll } from './value/scroll/use-element-scroll.js';
export { useViewportScroll } from './value/scroll/use-viewport-scroll.js';
export { useReducedMotion } from './utils/use-reduced-motion.js';
export { useAnimation } from './animation/use-animation.js';
export { useCycle } from './utils/use-cycle.js';
export { DragControls, useDragControls } from './gestures/drag/use-drag-controls.js';
export { useAnimatedState as useDeprecatedAnimatedState } from './animation/use-animated-state.js';
export { useInvertedScale as useDeprecatedInvertedScale } from './value/use-inverted-scale.js';
